import { Component, Input, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AccountService, AlertService, Constant } from '@app/_services';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { ConnectionService, AutomationService } from '../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { AutomationList, AutomationListRequestDTO, Role, triggerdetailforautomation, TriggerDetails, User } from '../_models';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { BaseService } from '@app/_services/base.service';


export interface Connection {
  automationID: number;
  automationName: string;
  aUID: string;
  status: string;
  cid: string;
  companyName: string;
  userId: number;
  userUID: string;
  connectorUID: string;
  connectorName: string;
  totalCount: number;
  actionAuthType: string;
}
interface AuthConnectionDetail {
  connectorName: string;
  description: string;
  status: string;
  authType: string;
  oauthlnk: string;
  clientid: string;
  clientsecret: string;
  authorizationURL: string;
  accesstokenreq: string;
  bodykey?: any;
  bvalue?: any;
}

@Component({
  templateUrl: 'automation.list.html',
  providers: [NgbProgressbarConfig]
})
export class AutomationListComponent implements OnInit {
  Connections: AutomationList[] = [];
  loading = false;
  url: string = "";
  userreturne: boolean;
  itemperpage: number = 5;
  uId: string;
  TriggerDetailforautomation: any;

  user: User;
  role = Role;
  companyName = '';

  paginagination = {
    collectionSize: 0,
    pageSize: 1,
    maxSize: 10,
  }
  currentPageNo = 0;
  isLoading = false;
  authLink = {
    clientId: '',
    redirectUrl: ''
  };

  teamsConnectorId = environment.teamsConnectorId;

  constructor(private connectionservice: ConnectionService,
    private alertService: AlertService,
    private constant: Constant,
    private route: ActivatedRoute,
    private automationservice: AutomationService,
    private spinner: NgxSpinnerService,
    private accountService: AccountService,
    private router: Router,
    config: NgbProgressbarConfig
  ) {
    this.accountService.user.subscribe(x => {
      this.user = x
    });
    config.max = 100;
    config.striped = true;
    config.animated = true;
    config.type = 'primary';
    config.height = '5px';
  }

  ngOnInit() {
    this.getAutomationList();
  }

  getAutomationList(offsetNo = 1) {
    this.isLoading = true;
    this.url = environment.logoURL;
    if (this.user.role == this.role.Admin) {
      const payload = new AutomationListRequestDTO();
      payload.offset = (offsetNo - 1) * 10;
      payload.companyName = this.companyName;
      this.automationservice.getAutomationList(payload)
        .subscribe(Connections => {
          this.isLoading = false;
          this.Connections = Connections;
          if (this.Connections && this.Connections.length > 0) {
            this.paginagination.collectionSize = this.Connections[0].totalCount;
          }

        });
    }
    this.uId = this.route.snapshot.params['uid'];
    if (this.user.role == this.role.Client) {
      this.automationservice.getUserAutomationList(this.uId)
        .pipe(first())
        .subscribe(Connections => {
          this.isLoading = false;
          this.Connections = Connections
        });
    }
  }

  deleteConnector(auID: string) {
    this.opensweetalert(auID);
  }
  opensweetalert(auID) {
    Swal.fire({
      title: 'Are you sure want to delete this Automation',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {

       // const Connection = this.Connections.find(x => x.aUID === auID);
        this.connectionservice.remove(auID)
          .pipe(first())
          .subscribe(data => {

            if (!data.isSuccess) {
              this.alertService.error(data.message);
            } else {
              this.alertService.clear();
              this.alertService.success(data.message);
              this.onRefresh();
            }
          });
        //this.automationservice.TriggerDetailForAutomation(auID)
        //  .pipe(first())
        //  .subscribe(
        //    data => {
        //      this.TriggerDetailforautomation = data;
        //      if (this.TriggerDetailforautomation.apiendpoint) {
        //        this.automationservice.AutomationWebHookDelete(this.TriggerDetailforautomation.apiendpoint, this.TriggerDetailforautomation.endpintusertoken)
        //          .pipe(first())
        //          .subscribe(
        //            data2 => {
        //              this.userreturne = data2;
        //              if (this.userreturne) {

        //              }
        //              else {
        //                this.alertService.error('Invalid User token', { keepAfterRouteChange: true });
        //              }
        //            }
        //          )
        //      }
        //    }
        //  )

      }
      else if (result.dismiss === Swal.DismissReason.cancel) {

      }
    })
  }
  ActicveInActive(aUID) {
    try {
      this.spinner.show();
      this.automationservice.getTriggerDetailsForAuotmationByRole(this.user.role,this.user.uId, aUID, data => {
            this.TriggerDetailforautomation = data;
            let flg = '';
            if (this.TriggerDetailforautomation.weebHookDetail.webhookurl.includes("RequestTeam")) {
              flg = 'TEAMS'
            } else {
              flg = 'SLACK'
            }
            if (this.TriggerDetailforautomation.triggerDetailForAutomation.apiendpoint) {
              this.automationservice.AutomationWebHookDelete(this.TriggerDetailforautomation.triggerDetailForAutomation.apiendpoint, this.TriggerDetailforautomation.triggerDetailForAutomation.endpintusertoken, flg,this.user.uId)
                .pipe(first())
                .subscribe(
                  data2 => {
                    this.userreturne = data2;
                    if (this.userreturne) {
                      this.connectionservice.ActiveAutomation(aUID,this.user.uId)
                        .pipe(first())
                        .subscribe(
                          data2 => {
                            if (data2.isSuccess) {
                              this.onRefresh();
                              this.spinner.hide();
                              this.alertService.success(data2.message, { keepAfterRouteChange: true });
                            }

                          },
                          error => {
                          });
                    }
                    else {
                      this.alertService.error('Invalid User token', { keepAfterRouteChange: true });
                    }
                  }
                )
            }
      })
    } catch {
      this.spinner.hide();
    }
  }
  Reinstall(aUID) {
    this.spinner.show();
    this.automationservice.AutomationTeamsReinstall(aUID).pipe(first()).subscribe(data => {
      if (data.isSuccess) {
        this.alertService.success("Teams app reinstalled");
      } else {
        this.alertService.error("App not reinstall");
      }
      this.spinner.hide();
    },error=>{
      this.spinner.hide();
      this.alertService.error("App not reinstall");
    });


  }
  onPublish(connection: Connection) {
    this.spinner.show();
    if (connection.actionAuthType == 'oauth') {
      
      this.connectionservice.getOpenAuthenticationConnectorDetail(connection.connectorUID)
        .pipe(first())
        .subscribe((data: AuthConnectionDetail) => {
          this.authLink = {
            clientId: data.clientid,
            redirectUrl: `${environment.slackPublishReturnURL}${connection.userUID}/action/${connection.aUID}`
          }
          let link = "";
          if (connection.connectorName == 'Slack') {
            //uninstall other active atomation for this user
            //this.connectionservice.getActiveAtomationIds(connection.userId, connection.automationID).subscribe((res: any) => { });
            localStorage.setItem("userId", connection.userId.toString());
            localStorage.setItem("automationID", connection.automationID.toString());
            const stateKey=this.automationservice.uniqueId();
            localStorage.setItem("stateKey",stateKey); 
            /* link = `https://slack.com/oauth/v2/authorize?client_id=${this.authLink.clientId}&scope=chat:write&state=${stateKey}&redirect_uri=${this.authLink.redirectUrl}&user_scope=`;*/
            //link = `https://slack.com/oauth/v2/authorize?client_id=${this.authLink.clientId}&scope=chat:write&state=${stateKey}&redirect_uri=${this.authLink.redirectUrl}&user_scope=`;
            link = `https://slack.com/oauth/v2/authorize?client_id=${this.authLink.clientId}&scope=chat:write,users:read,users:read.email&state=${stateKey}&redirect_uri=${this.authLink.redirectUrl}&user_scope=`;
          }

          if (connection.connectorName == 'Microsoft Teams') {
            link = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=${this.authLink.clientId}&scope=https%3A%2F%2Fgraph.microsoft.com%2F.default%20offline_access&redirect_uri=${environment.TeamsReturnURL}&prompt=select_account`
            localStorage.setItem('uid', connection.userUID);
            localStorage.setItem('auid', connection.aUID);
            localStorage.setItem('client_id', data.clientid);
            localStorage.setItem('clientsecret', data.clientsecret);
            localStorage.setItem('TeamsReturnURL', environment.TeamsReturnURL);
            localStorage.setItem('For', 'action');
            localStorage.setItem('IsPublish', '1');
          }
          window.open(link, "_self");
          this.spinner.hide();

        });
    } else {
      this.activateAutomation(connection);
    }
  }

  onUnpublish(connection: Connection) {
    localStorage.removeItem("userId");
    localStorage.removeItem("automationID");
    this.spinner.show();
    if (connection.actionAuthType == 'oauth') {
      this.connectionservice.RevokeAuthorization(connection.automationID)
        .pipe(first())
        .subscribe(data => {
          if (data && data.status == true) {
            this.getAutomationList();
            this.alertService.success(data.message);
          }
          else {
            this.alertService.error(data.message);
          }
          this.spinner.hide();
        });
    } 
  }

  activateAutomation(connection: Connection) {
    let triggerDetails: TriggerDetails;
    this.automationservice.getTriggerDetailsForAuotmationByRole(this.user.role,this.user.uId, connection.aUID, data => {
      if (data) {
        triggerDetails = data;
        let flg = '';
        if (triggerDetails.weebHookDetail != null && triggerDetails.weebHookDetail.webhookurl.includes("RequestTeam")) {
          flg = 'TEAMS'
        } else {
          flg = 'SLACK'
        }

        if (triggerDetails.triggerDetailForAutomation.apiendpoint) {
          this.automationservice.AutomationWebHookPost(triggerDetails.triggerDetailForAutomation.apiendpoint,
            triggerDetails.triggerDetailForAutomation.endpintusertoken, triggerDetails.weebHookDetail.webhookurl + connection.aUID, flg)
            .pipe(first())
            .subscribe(
              data2 => {
                this.userreturne = data2;
                if (this.userreturne) {
                  this.connectionservice.ActiveAutomation(connection.aUID,this.user.uId)
                    .pipe(first())
                    .subscribe(
                      data2 => {
                        try {
                          if (this.user && this.user.role == Role.Client && this.user.name != null) {
                            this.automationservice.mailOnAutomationComplete(connection.aUID).subscribe(x => { });
                          }
                        } catch { }
                        this.alertService.success(data2.message, { keepAfterRouteChange: true });
                        this.spinner.hide();
                      },
                      error => {
                        this.spinner.hide();
                      });
                }
                else {
                  this.alertService.error('Invalid User token', { keepAfterRouteChange: true });
                  this.spinner.hide();
                }
              },
              error => {
                if (error == "Bad Request")
                  error = "Invalid Authentication URL OR server is Down";
                this.spinner.hide();
                this.alertService.error(error);

              }
            )
        } else {
          this.spinner.hide();
        }


      }
    })
  }

  onChangePage($event: number) {
    this.getAutomationList($event);
  }
  onSearchByCompanyName() {
    this.paginagination.pageSize = 1
    this.getAutomationList();
  }
  onRefresh() {
    this.getAutomationList(this.paginagination.pageSize);
  }
}
